<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="list mtb80">
                    <div class="table">
                        <table>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>제목</th>
                                    <th>문의유형</th>
                                    <th>날짜</th>
                                </tr>
                            </thead>
                            <tbody v-if="list && list.length > 0">
                                <tr v-for="(row, index) in list" :key="row.id">
                                    <td>
                                        <template v-if="pagination">
                                            {{ pagination.total - ((pagination.current_page - 1) * pagination.per_page) - index }}
                                        </template>
                                        <template v-else>
                                            {{ index + 1 }}
                                        </template>
                                    </td>
                                    <td>
                                        <span class="title" @click="goDetail(row.id)" style="cursor:pointer">
                                            {{ row.title }}
                                        </span>
                                    </td>
                                    <td>{{ typeMap[row.type] || '기타' }}</td>
                                    <td>{{ formatDate(row.created_at) }}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="4" style="padding: 50px 0;">문의 내역이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination" v-if="pagination && pagination.last_page > 1">
                        <a href="#" class="prev" v-if="pagination.current_page > 1" @click.prevent="goPage(pagination.current_page - 1)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.45 12.08">
                                <path d="M.71,11.37l5.33-5.33L.71.71" fill="none" stroke="#1b1e23" stroke-width="2"/>
                            </svg>
                        </a>

                        <a href="#" v-for="page in pagination.last_page" :key="page" :class="{ active: page === pagination.current_page }" @click.prevent="goPage(page)">
                            {{ page }}
                        </a>

                        <a href="#" class="next" v-if="pagination.current_page < pagination.last_page" @click.prevent="goPage(pagination.current_page + 1)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.45 12.08">
                                <path d="M.71,11.37l5.33-5.33L.71.71" fill="none" stroke="#1b1e23" stroke-width="2"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
import api from '@/api'
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

export default {
    name: 'InquireHistory',
    components: { TheHeader, TheFooter },

    data() {
        return {
            userid: null,
            list: [], // 초기값을 빈 배열로 설정
            pagination: null,
            typeMap: {
                1: '회원가입 및 로그인',
                2: 'BIM-라이브러리 마켓',
                3: '설계 및 시뮬레이션',
                4: '포인트 충전 및 환불',
                5: '유지관리 서비스',
                6: '온라인 세미나/교육',
                7: '홍보업체등록',
                8: 'ZEB 제조사'    
            }
        }
    },

    async mounted() {
        await this.checkLogin()
        
        if (!this.$route.query.page) {
            this.$router.replace({
                path: this.$route.path,
                query: { page: 1 }
            })
        }
    },

    watch: {
        userid: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.loadInquiry()
                }
            }
        },
        '$route.query.page'() {
            this.loadInquiry()
        }
    },

    methods: {
        async checkLogin() {
            try {
                const res = await api.get('/admin/user-info', { withCredentials: true })
                if (res.data && res.data.loggedIn) {
                    this.userid = res.data.user.id
                } else {
                    this.redirectLogin()
                }
            } catch (e) {
                this.redirectLogin()
            }
        },

        async loadInquiry() {
            if (!this.userid) return

            try {
                const res = await api.get('/admin/inquiry_my_list', {
                    params: {
                        userid: this.userid,
                        page: this.$route.query.page || 1
                    },
                    withCredentials: true
                })

                // API 응답 데이터 구조 매핑 (콘솔 데이터 결과에 맞춰 조정)
                if (res.data && res.data.data) {
                    this.list = res.data.data
                    this.pagination = res.data
                } else if (Array.isArray(res.data)) {
                    this.list = res.data
                }
            } catch (e) {
                console.error('Data Load Error:', e)
            }
        },

        redirectLogin() {
            const referer = this.$route.fullPath
            window.location.href = `/login_form?referer=${encodeURIComponent(referer)}`
        },

        goPage(page) {
            if (!this.pagination || page < 1 || page > this.pagination.last_page) return
            this.$router.push({ path: this.$route.path, query: { page } })
        },

        goDetail(id) {
            this.$router.push(`/inquire_view?id=${id}`)
        },

        formatDate(date) {
            if (!date) return '-'
            // date가 문자열인지 확인 후 자르기
            return typeof date === 'string' ? date.substring(0, 10) : date
        }
    }
}
</script>